function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
  fill: "#DF4532"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0244 18.6475H13.9619C14.7891 18.6475 15.2061 18.3809 15.6367 17.9023L18.0088 15.2705C18.4395 14.7852 18.5488 14.4707 18.5488 13.8145V10.9023C18.5488 10.2461 18.4395 9.93164 18.0088 9.44629L15.6367 6.80762C15.2061 6.33594 14.7891 6.0625 13.9619 6.0625H10.0244C9.2041 6.0625 8.78711 6.33594 8.35645 6.80762L5.98438 9.44629C5.55371 9.93164 5.4375 10.2461 5.4375 10.9023V13.8145C5.4375 14.4707 5.55371 14.7852 5.98438 15.2705L8.35645 17.9023C8.78711 18.3809 9.2041 18.6475 10.0244 18.6475ZM10.3594 17.5332C9.73047 17.5332 9.53906 17.3965 9.18359 17.0068L7.02344 14.6211C6.76367 14.334 6.70898 14.1699 6.70898 13.6914V11.0186C6.70898 10.5469 6.76367 10.3828 7.02344 10.0957L9.18359 7.70312C9.53906 7.32031 9.73047 7.17676 10.3594 7.17676H13.627C14.2627 7.17676 14.4541 7.32031 14.8096 7.70312L16.9697 10.0957C17.2227 10.3828 17.2842 10.5469 17.2842 11.0186V13.6914C17.2842 14.1699 17.2227 14.334 16.9697 14.6211L14.8096 17.0068C14.4541 17.3965 14.2627 17.5332 13.627 17.5332H10.3594ZM12 13.4863C12.3213 13.4863 12.5059 13.3018 12.5195 12.9531L12.6084 9.64453C12.6221 9.2959 12.3486 9.04297 11.9932 9.04297C11.624 9.04297 11.3643 9.28906 11.3779 9.6377L11.4668 12.9531C11.4736 13.3018 11.6582 13.4863 12 13.4863ZM12 15.6055C12.3828 15.6055 12.7178 15.3047 12.7178 14.9219C12.7178 14.5322 12.3896 14.2314 12 14.2314C11.6035 14.2314 11.2754 14.5322 11.2754 14.9219C11.2754 15.2979 11.6104 15.6055 12 15.6055Z",
  fill: "url(#paint0_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 11.75,
  y1: 10.8108,
  x2: 2.04084,
  y2: 19.7888,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F6F7F8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F6F8F9"
})));

function SvgIconStateFailed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStateFailed);
export default __webpack_public_path__ + "static/media/icon-state-failed.b31bcb90.svg";
export { ForwardRef as ReactComponent };